import React, { FC, useState } from "react";
import { message } from "antd";
import { downloadAllFiles, taxDocFileUrl } from "../../../services/taxDocService";
import DocumentsUpload from "../../../components/documentsUpload";
import TaxDocCaseStore from "../../../contexts/taxDocCaseStore";
import _t from "../../../lang/translate";
import CollapseCard from "../../../components/collapseCard";
import { isAxiosError } from "../../../utilities/typeGuard";

const TaxDocAttachments: FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const { taxDocCase, setTaxDocCase, isAdmin } = TaxDocCaseStore.useContainer();

  const handleDownloadAll = async () => {
    try {
      setLoading(true);
      const { data } = await downloadAllFiles(taxDocCase.id);
      if (data?.url) window.open(data.url, "_blank");
    } catch (error) {
      const errorMessage = isAxiosError(error) ? error.response?.data?.message : null;
      message.error(errorMessage || _t("msg.unknown_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <CollapseCard title={_t("attachments")} loading={loading}>
      <DocumentsUpload
        onDownloadAll={handleDownloadAll}
        fileList={taxDocCase.files || []}
        canLockFiles={isAdmin}
        onChange={({ fileList }) => {
          setTaxDocCase({ ...taxDocCase, files: fileList });
        }}
        action={taxDocFileUrl(taxDocCase?.id)}
      />
    </CollapseCard>
  );
};

export default TaxDocAttachments;
